export const gitCommit = 'db2cce2b'
